import React from "react";
import Skeleton from "./Skeleton";
import skeletonStyles from "../../style/skeleton.module.css";

const ContactPageSkeleton = () => (
  <div
    className="container page-shell pb-4 pt-md-5 pt-3 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading contact page"
  >
    <div className="row g-4 gy-4">
      <div className="col-12 col-lg-6">
        <Skeleton className={skeletonStyles.skeletonTitle} />
        <div className={`${skeletonStyles.skeletonContactForm} mt-4`}>
          <Skeleton className={skeletonStyles.skeletonInput} />
          <Skeleton className={skeletonStyles.skeletonInput} />
          <Skeleton className={skeletonStyles.skeletonTextarea} />
          <Skeleton className={skeletonStyles.skeletonButton} />
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <Skeleton className={skeletonStyles.skeletonSubtitle} />
        <div className={skeletonStyles.skeletonLegalAccordion}>
          <Skeleton className={skeletonStyles.skeletonLegalItem} />
          <Skeleton className={skeletonStyles.skeletonLegalItem} />
          <Skeleton className={skeletonStyles.skeletonLegalItem} />
        </div>
      </div>
    </div>
  </div>
);

export default ContactPageSkeleton;
